import { render, staticRenderFns } from "./HiLitesSidebar.vue?vue&type=template&id=584899a8&scoped=true&"
import script from "./HiLitesSidebar.vue?vue&type=script&lang=js&"
export * from "./HiLitesSidebar.vue?vue&type=script&lang=js&"
import style0 from "./HiLitesSidebar.vue?vue&type=style&index=0&id=584899a8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584899a8",
  null
  
)

export default component.exports